import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
} from "chart.js";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    entities: null,
    annual: null,
    monthly: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    entities: string[];
    annual: number[];
    monthly: number[];
  }

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors
);


const options = computed(() => ({
  plugins: {
    title: {
      display: true,
      text: props.title,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      display: false,
    },
  },
  indexAxis: "y",
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        callback: (value) => `${value} %`,
      },
    },
  },
}));
const chartData = computed(() => ({
  labels: props.entities,
  datasets: [
    { data: props.monthly, label: "Mensual" },
    { data: props.annual, label: "Anual" },
  ],
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Bar), {
      data: _unref(chartData),
      options: _unref(options)
    }, null, 8, ["data", "options"])
  ]))
}
}

})